import { render } from "./list-courier-partner-section-v2.vue?vue&type=template&id=5f2e824b&ts=true"
import script from "./list-courier-partner-section-v2.vue?vue&type=script&lang=ts"
export * from "./list-courier-partner-section-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__